<template>
    <div>
        <p v-if="content">{{ content }} <span class="t-[theme] cursor-pointer ml-[4]" @click="copyItem(content)">{{
            show_copy ? '已复制' : '复制' }}</span></p>
    </div>
</template>
<script>
import { copyText } from "@/assets/js/utils";
export default {
    name: "dg-copy",
    props: {
        content: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            show_copy: false,
            timer: null,
        };
    },
    methods: {
        setTime() {
            this.show_copy = true
            this.timer = setTimeout(() => {
                this.show_copy = false;
                clearTimeout(this.timer)
                this.timer = null
            }, 3000);
        },
        // 复制信息
        copyItem(content) {
            if (this.show_copy) return
            let txt = content;
            if (navigator.clipboard && window.isSecureContext) {
                // // this.message_success("复制成功");
                // this.setTime()
                // return navigator.clipboard.writeText(txt);
                copyText(txt, () => {
                    this.setTime()
                })
            } else {
                let   textArea = document.createElement("textarea");
                textArea.value = txt;
                document.body.appendChild(textArea);
                // textArea.focus();
                textArea.select();
                // this.message_success("复制成功");
                this.setTime()
                return new Promise((res, rej) => {
                    document.execCommand("copy") ? res() : rej();
                    textArea.remove();
                });
            }
        },
    },
    mounted() { },
    created() { },
};
</script>
<style scoped></style>